export { default as ThemeMutationObserver } from '../theme-mutation-observer';
